module.exports = __webpack_public_path__ + "static/the-prophet-bb8e800d72f4894bc4aad7c9a54dcb0c.jpg";